import React from 'react';
import PropTypes from 'prop-types';
import { LogoWrapper } from './styles';

const TeamBigLogo = ({
  size, margin, withCursor, alignSelf, image, isDriver,
}) => (
  <LogoWrapper
    withCursor={withCursor}
    size={size}
    margin={margin}
    alignSelf={alignSelf}
    src={image}
    isDriver={isDriver}
    onError={(e) => {
      e.target.src = 'https://images2.gazzettaobjects.it/assets-mc/countries/med/noflag.svg';
    }}
  />
);

TeamBigLogo.propTypes = {
  size: PropTypes.number,
  margin: PropTypes.any,
  withCursor: PropTypes.bool,
  alignSelf: PropTypes.string,
  image: PropTypes.any,
  isDriver: PropTypes.bool,
};


export default TeamBigLogo;



// WEBPACK FOOTER //
// ./src/lib/components/shared/TeamBigLogo/index.js